import { Button } from 'devextreme-react';
import styles from './PopupBody.module.css';

export interface PopupButtonConfig {
  text: string;
  onClick: () => void;
  type?: React.ComponentProps<typeof Button>['type'];
  disabled?: boolean;
  // type: (typeof Button)['type'];
}

interface PopupBodyProps {
  children: React.ReactNode;
  buttonConfig?: PopupButtonConfig[];
}

function PopupBody(props: PopupBodyProps) {
  return (
    <div className={styles.popup}>
      <div>{props.children}</div>
      {!!props.buttonConfig && (
        <div className={styles.buttonGroup}>
          {props.buttonConfig.map((button) => (
            <Button key={button.text} onClick={button.onClick} type={button.type ?? 'normal'} disabled={!!button.disabled}>
              {button.text}
            </Button>
          ))}
        </div>
      )}
    </div>
  );
}

export default PopupBody;
